/* Updates the existing campaign price fields; does not add or change cart items. */
(() => {
  'use strict';
  if (window.__apologyBundlePrices) return;
  window.__apologyBundlePrices = true;
  const selector = '.apology-bundle__price, .apology-bundle__add-button-price, .apology-sticky-cart__price';
  let queued = false;

  function plainMoney(value) {
    const element = document.createElement('span');
    element.innerHTML = value;
    return element.textContent.trim();
  }

  function updateComparison(bundle, config) {
    const mainPrice = bundle.querySelector('.apology-bundle__price');
    let comparison = bundle.querySelector('[data-apology-bundle-comparison]');
    const valid = mainPrice && Number.isSafeInteger(config.referenceTotal)
      && config.referenceTotal > config.total
      && typeof config.referenceFormatted === 'string' && config.referenceFormatted.trim();
    if (!valid) {
      comparison?.remove();
      return;
    }
    if (!comparison) {
      comparison = document.createElement('p');
      comparison.className = 'apology-bundle__price-comparison';
      comparison.setAttribute('data-apology-bundle-comparison', '');
      const label = document.createElement('span');
      label.textContent = 'ALL 4 ITEMS SEPARATELY';
      const amount = document.createElement('s');
      amount.setAttribute('data-apology-bundle-reference-amount', '');
      comparison.append(label, amount);
      mainPrice.before(comparison);
    }
    const amount = comparison.querySelector('[data-apology-bundle-reference-amount]');
    const text = plainMoney(config.referenceFormatted);
    if (amount.textContent !== text) amount.textContent = text;
  }

  function updatePrices() {
    queued = false;
    const bundle = document.querySelector('[data-apology-bundle]');
    if (!bundle) return;
    let config;
    try {
      config = JSON.parse(document.getElementById('apology-bundle-price-config')?.textContent || 'null');
    } catch (_) { config = null; }
    const variants = ['mainVariantId', 'earringsVariantId', 'giftWrapVariantId', 'giftBagVariantId']
      .map((key) => String(bundle.dataset[key] || ''));
    const valid = config?.valid === true && Number.isSafeInteger(config.total) && config.total >= 0
      && typeof config.formatted === 'string' && config.formatted.trim()
      && /^[A-Z]{3}$/.test(config.currency || '') && config.variants?.length === 4
      && config.variants.every((id, index) => String(id) === variants[index]);
    if (!valid) {
      bundle.querySelector('[data-apology-bundle-comparison]')?.remove();
      document.documentElement.classList.remove('apology-bundle-pricing-ready');
      document.querySelectorAll(selector).forEach((element) => {
        if (element.textContent) element.textContent = '';
      });
      const sticky = document.querySelector('.apology-sticky-cart');
      if (sticky) sticky.setAttribute('aria-label', 'Add bundle to cart');
      return;
    }
    // money_with_currency may contain Shopify formatting spans and entities.
    const formatted = document.createElement('span');
    formatted.innerHTML = config.formatted;
    const price = formatted.textContent.trim();
    document.querySelectorAll(selector).forEach((element) => {
      if (element.textContent !== price) element.textContent = price;
    });
    updateComparison(bundle, config);
    const sticky = document.querySelector('.apology-sticky-cart');
    if (sticky) {
      // The original campaign script creates this button after window.load.
      let amount = sticky.querySelector('.apology-sticky-cart__price');
      if (!amount) {
        amount = document.createElement('span');
        amount.className = 'apology-sticky-cart__price';
        amount.textContent = price;
        sticky.appendChild(amount);
      }
      const label = `Add bundle to cart, ${price}`;
      if (sticky.getAttribute('aria-label') !== label) sticky.setAttribute('aria-label', label);
    }
    document.documentElement.classList.add('apology-bundle-pricing-ready');
  }

  function queueUpdate() {
    if (queued) return;
    queued = true;
    queueMicrotask(updatePrices);
  }

  new MutationObserver((records) => {
    if (records.some((record) => record.target.closest?.(selector)
      || record.target.id === 'apology-bundle-price-config'
      || Array.from(record.addedNodes).some((node) => node.nodeType === 1
        && (node.matches?.(selector + ', .apology-sticky-cart, [data-apology-bundle], #apology-bundle-price-config')
          || node.querySelector?.(selector))))) queueUpdate();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', queueUpdate);
  window.addEventListener('pageshow', queueUpdate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updatePrices, { once: true });
  else updatePrices();
})();
